/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable no-nested-ternary */
import React from 'react'
import Link from 'next/link'
import PropTypes from 'prop-types'
import ScrollableList from '../ScrollableList'
import Image from '../Image'
import styles from './styles'

const ScrollerMenu = ({ menuItems }) => (
  <section id="sectionId">
    <ScrollableList role="tablist" className="live-dropdown">
      {menuItems.map(item => (
        <div className={`image-dropdown ${item.isActiveItem ? 'active' : ''}`}>
          <Link href={item.href} as={item.href} passHref legacyBehavior>
            <a className="menu-link" href={item.href} id={item.id}>
              <Image
                image={item.logo}
                className="dropdown-image"
                alt={`${item.title} channel logo`}
              />
            </a>
          </Link>
        </div>
      ))}

    </ScrollableList>
    <style jsx>{styles}</style>
  </section>
)

ScrollerMenu.propTypes = {
  menuItems: PropTypes.arrayOf(PropTypes.object), // eslint-disable-line react/forbid-prop-types
}

ScrollerMenu.defaultProps = {
  menuItems: [{}],
}

export default ScrollerMenu
